
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[ssgParams]/products/reviews",
      function () {
        return require("private-next-pages/[ssgParams]/products/reviews.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[ssgParams]/products/reviews"])
      });
    }
  